import { Template, TemplateListItem } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for business templates.
 */
export class BusinessTemplates extends CrudApiBase<Template, TemplateListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/templates";

  constructor(ajax: Ajax) {
    super(ajax);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): Template {
    return {};
  }
}
